var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title)?_c('div',{staticClass:"main-title"},[(_vm.$route.meta.showBack !== false)?_c('div',{staticClass:"main-title-back bg-theme",on:{"click":function($event){return _vm.$router.back()}}},[_c('Icon',{attrs:{"type":"ios-arrow-back"}})],1):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.title))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }